export default __webpack_public_path__ + "static/media/04d_fold-22.73e4e24d.mp4";